import { createSelector } from 'reselect'

import { currentOrganizationSelector } from 'selectors/current_organization'

export const nameSelector = createSelector(
  currentOrganizationSelector,
  ({ name }) => name || ''
)
